import { useTranslation } from "react-i18next";
import "./i18n"; // Import the i18n setup
import { Link, useLocation } from "react-router-dom";

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const currentPath = location.pathname;

  const getPathForLang = (newLang: "en" | "cs") => {
    return currentPath.replace(/^\/(en|cs)/, `/${newLang}`);
  };

  const newLang = i18n.language === "en" ? "cs" : "en";
  const flagUrl = i18n.language === "en" ? "/czeFlag.png" : "/ukFlag.png";

  return (
    <Link to={getPathForLang(newLang)}>
      <div
        style={{
          paddingBottom: 35,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
        }}
      >
        <img
          src={flagUrl}
          alt="image"
          style={{
            height: 16,
            paddingRight: 16,
          }}
        />
        <a>{t("switchLanguage")}</a>
      </div>
    </Link>
  );
}
